import { MapPin, Handshake } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function BringTraditionToYourTable() {
  return <section data-section-id="243441" id="secure-your-propertys-future" className="dark bg-primary text-primary-foreground py-24 sm:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658340/img/foundation_construction_site.png" alt="Modern home foundation under construction" className="w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-primary/70" />
      </div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center flex flex-col items-center">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-balance text-white">
            Protect Your Investment with 40 Years of Expertise
          </h2>
          
          <p className="text-lg md:text-xl text-primary-foreground/80 mb-10 max-w-2xl text-balance">
            Mohammed Saleem, P.E., provides specialized structural evaluations and foundation engineering for residential and commercial properties.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
            <Button asChild size="lg" className="w-full sm:w-auto text-base h-14 px-8 rounded-none bg-[#f97316] hover:bg-[#f97316]/90 text-white shadow-lg hover:shadow-[#f97316]/20 transition-all">
              <Link to="/ConsultationPage">
                <MapPin className="mr-2 size-5" />
                Schedule Your Evaluation
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base h-14 px-8 rounded-none border-2 border-white text-white hover:bg-white hover:text-primary bg-transparent transition-all">
              <Link to="/ExpertisePage">
                <Handshake className="mr-2 size-5" />
                Our Engineering Services
              </Link>
            </Button>
          </div>
          
          <p className="mt-8 font-mono text-xs uppercase tracking-widest text-primary-foreground/60">Available in CA and UT</p>
        </div>
      </div>
    </section>;
}